import React, { useState } from 'react';
import { Copy, Loader2, MessageCircle } from 'lucide-react';
import api from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { toast } from 'sonner';

export function ReponsesCommentaires({ marque = 'bureau_agricole' }) {
  const [commentaire, setCommentaire] = useState('');
  const [reponses, setReponses] = useState([]);
  const [charge, setCharge] = useState(false);
  const proposer = async () => {
    setCharge(true);
    try { setReponses((await api.post('/videos-virales/commentaires/reponses', { marque, commentaire })).data.reponses); }
    catch (e) { toast.error(e.response?.data?.detail?.toString() || 'Réponses indisponibles'); }
    setCharge(false);
  };
  return (
    <div className="rounded-2xl border border-stone-200 bg-white p-5 space-y-3" data-testid="vv-commentaires">
      <h2 className="font-semibold flex items-center gap-2"><MessageCircle className="w-4 h-4 text-primary" />Répondre à un commentaire</h2>
      <Textarea rows={3} value={commentaire} onChange={(e) => setCommentaire(e.target.value)} placeholder="Collez ici le commentaire reçu sur Instagram, Facebook ou YouTube" data-testid="vv-commentaire" />
      <Button size="sm" onClick={proposer} disabled={!commentaire.trim() || charge} data-testid="vv-proposer-reponses">
        {charge && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}Proposer 3 réponses
      </Button>
      {reponses.map((r, i) => (
        <div key={i} className="flex items-start gap-2 rounded-lg bg-stone-50 p-3 text-sm" data-testid={`vv-reponse-${i}`}>
          <p className="flex-1">{r}</p>
          <Button size="icon" variant="ghost" className="h-7 w-7" onClick={() => { navigator.clipboard.writeText(r); toast.success('Réponse copiée'); }} data-testid={`vv-copier-reponse-${i}`}><Copy className="w-3.5 h-3.5" /></Button>
        </div>
      ))}
      {reponses.length > 0 && <p className="text-[11px] text-stone-500">Rien n'est publié : copiez la réponse choisie et collez-la vous-même.</p>}
    </div>
  );
}
